import React from 'react';
import { NavLink } from 'react-router-dom';
import { SquircleBox } from '../design_system/shapes/SquircleBox';
import styles from './SidebarItem.module.css';

export default function SidebarItem({ item, collapsed = false }) {
  return (
    <li className={styles.item}>
      <NavLink
        to={item.route}
        end={item.route === '/'}
        className={styles.link}
        aria-label={collapsed ? item.label : undefined}
        title={collapsed ? item.label : undefined}
      >
        {({ isActive }) => (
          <SquircleBox
            shape="md"
            className={[
              styles.linkShell,
              isActive ? styles.linkShellActive : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <span
              className={[
                styles.linkContent,
                collapsed ? styles.linkContentCollapsed : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {item.icon ? <span className={styles.linkIcon} aria-hidden="true">{item.icon}</span> : null}
              <span
                className={[
                  styles.linkLabel,
                  collapsed ? styles.linkLabelCollapsed : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {item.label}
              </span>
            </span>
          </SquircleBox>
        )}
      </NavLink>
    </li>
  );
}

